module.exports = __webpack_public_path__ + "img/92091.30367422.svg";